export default "__VITE_ASSET__C8Hz30pK__"